export const UPDATE_SOCIAL_LOGINS = 'UPDATE_SOCIAL_LOGINS';

export const updateSocialLogins = logins => ({
    type: UPDATE_SOCIAL_LOGINS,
    logins
});
